import { createRoutine } from "../utils/routine.utils";
export var getPartnerships = createRoutine("PARTNERSHIPS_GET");
export var getPartnershipsByBrokerId = createRoutine("PARTNERSHIPS_GET_BY_BROKER_ID");
export var requestLocationDescription = createRoutine("PARTNERSHIPS_REQUEST_LOCATION_DESCRIPTION");
